<section class="estimates py-5">
  <div class="container">
    <div class="vam_estimates_main_container">
      <div class="vam_estimates_title text-center mb-5">
        <h4 class="m-0">{{'estimates.estimated_price_calculator' | translate}}</h4>
      </div>

      <form class="vam_estimates_form credential pb-4" [formGroup]="estimateForm" (submit)="saveData()">
        <div class="row estimate_price_hed"
          *ngIf="estimatePriceData && ['admin', 'purchasemanager', roleType.purchaser, 'salesmanager', 'salesperson'].includes(role)">
          <div class="px-2"
            [class]="[roleType.purchaser, roleType.purchasemanager].includes(role) ? 'col-12' : 'col-sm-6'"
            *ngIf="['admin', 'purchasemanager', 'purchaser'].includes(role)">
            <div class="vam_estimates_title mb-4">
              <h5 class="m-0">{{ 'purchase_decision' | translate }}</h5>
            </div>
            <!-- Purchase type setup -->

            <div class="form-group"
              *ngIf="[roleType.purchaser, roleType.admin, roleType.purchasemanager].includes(role)">
              <label class="credential__label">{{ "estimates.purchase_type" | translate }}</label>
              <select name="purchase_type" formControlName="purchase_type"
                [attr.disabled]="roleType.purchasemanager === role ? true : null"
                [class.is-invalid]="formData.purchase_type.invalid && submitted"
                class="form-control credential__select-lg" #purchaseType
                (change)="estimatePurchaseTypeSelect(purchaseType.value)">
                <option value="" selected>Select {{ "estimates.purchase_type" | translate }}</option>
                <option [value]="item['purchase_types_id']" *ngFor="let item of purchaseList">
                  <ng-container *ngIf="lang == 'en'">{{item.purchase_types_name}}</ng-container>
                  <ng-container *ngIf="lang == 'ar'">{{item.purchase_types_arabic_name}}</ng-container>
                </option>
              </select>

              <div class="form-errors" *ngIf="formData.purchase_type.invalid && this.submitted">
                <p class="form-errors__error" *ngIf="formData.purchase_type.errors.required">
                  {{ "estimates.purchase_type" | translate }} required
                </p>
              </div>
            </div>

            <div class="form-group" *ngIf="isEstimateUpdated">
              <label class="credential__label"> {{ 'purchase_price' | translate }} (<small>{{ 'estimates.with_vat' |
                  translate }}</small>) </label>
              <input type="text" class="form-control credential__input-lg p-3" [placeholder]='"Purchase Price"'
                name="buy_price" formControlName="buy_price"
                [class.is-invalid]="estimateForm.controls.buy_price.errors && submitted"
                (blur)="priceChangeVal($event, 'buy_price')">
            </div>
            <div class="form-group">
              <ngx-slider [(value)]="purchaseMinVal" [options]="purchaseOptions"
                (userChangeEnd)="sliderEve($event, 'buy_price')"></ngx-slider>
            </div>
            <div class="btn-group price_btn_all mb-3" role="group" *ngIf="!disableForm">
              <input type="radio" class="btn-check" name="suggestion_type" id="btnradioyes">
              <label class="btn btn__primary btn-outline-primary brdr-radius-left bg-highlight-yes" for="btnradioyes"
                (click)="activePurchaseSuggestion = 1; this.purchaseApproveStatus = 1; alertTo = 'alert_pm'"
                [class.btn_yes]="activePurchaseSuggestion === 1">Yes</label>

              <input type="radio" class="btn-check" name="suggestion_type" id="btnradiono">
              <label class="btn btn__primary btn-outline-primary bg-highlight-no" for="btnradiono"
                (click)="activePurchaseSuggestion = 0; this.purchaseApproveStatus = 0; alertTo = 'alert_pm'"
                [class.btn_no]="activePurchaseSuggestion === 0">No</label>
            </div>

            <div class="col px-2" *ngIf="isAlert && estimateDetails">
              <div class="button_act"
                *ngIf="(role === 'admin' || role === 'purchasemanager') && !estimateDetails['purchase_order']">
                <ng-container *ngIf="!disableForm">
                  <button class="btn btn__primary button"
                    [disabled]="vehicleInformation['alert_pm'] && vehicleInformation['admin_approved'] > -1"
                    [class.btn_yes]="vehicleInformation['alert_pm'] && vehicleInformation['admin_approved']"
                    (click)="purchaseApproval(1)" type="button">Approve</button>
                  <button class="btn btn__primary button"
                    [disabled]="vehicleInformation['alert_pm'] && vehicleInformation['admin_approved'] > -1"
                    [class.btn_no]="vehicleInformation['alert_pm'] && !vehicleInformation['admin_approved']"
                    (click)="purchaseApproval(2)" type="button">Disapprove</button>
                </ng-container>
              </div>
            </div>

            <ng-container
              *ngIf="vehicleInformation['pm_approved'] == 2 && ['admin', 'purchaser', 'purchasemanager'].includes(role)">
              <p>Purchase Price Disapproved</p>
            </ng-container>
            <p *ngIf="estimatePriceData" class="mt-4 mb-1">Repair cost: {{estimateForm.get('repair_total_cost').value}}
            </p>
            <p *ngIf="estimateDetails && estimateDetails['purchase_order']">Purchase order created<span *ngIf=""> on
                {{estimateDetails['purchase_order_date']}}</span>.</p>

          </div>
          <div class="px-2" [class]="['salesmanager', 'salesperson'].includes(role) ? 'col-12' : 'col-sm-6'"
            *ngIf="['admin', 'salesmanager', 'salesperson'].includes(role)">
            <div class="vam_estimates_title mb-4">
              <h5 class="m-0">{{ 'selling_decision' | translate }}</h5>
            </div>
            <div class="form-group">
              <label class="credential__label"> {{ 'selling_price' | translate }} (<small>{{ 'estimates.with_vat' |
                  translate }}</small>)</label>
              <input type="text" class="form-control credential__input-lg p-3" [placeholder]='"Selling Price"'
                name="sell_price" formControlName="sell_price"
                [class.is-invalid]="estimateForm.controls.sell_price.errors && submitted"
                (blur)="priceChangeVal($event, 'sell_price')">
            </div>
            <div class="form-group">
              <ngx-slider [(value)]="saleMaxVal" [options]="saleOptions"
                (userChangeEnd)="sliderEve($event, 'sell_price')"></ngx-slider>
            </div>
            <div class="col px-2"
              *ngIf="!estimateForm.get('sales_order').value && isSalesAlert && ['admin', 'salesmanager'].includes(role)">
              <div class="button_act" *ngIf="role === 'admin' || role ==='salesmanager'">
                <ng-container *ngIf="!disableForm">
                  <button class="btn btn__primary button" (click)="salesupdateAlert(true)"
                    type="button">Approve</button>
                  <button class="btn btn__primary button " (click)="salesupdateAlert(false)"
                    type="button">Reject</button>
                </ng-container>
              </div>
            </div>

            <ng-container
              *ngIf="vehicleInformation['sm_approved'] == 2 && ['admin', 'salesmanager', 'salesperson'].includes(role)">
              <p>Sales Price Disapproved</p>
            </ng-container>
            <ng-container *ngIf="estimateDetails && estimateDetails['sales_order']">
              <p>Sales order created<span *ngIf="estimateDetails['sales_order_date']"> on
                  {{estimateDetails['sales_order_date']}}</span>.</p>
            </ng-container>
          </div>
        </div>
        <div class="row mx-n2 d-none">
          <div class="col-sm-6 px-2 mb-3">
            <div class="form-group">
              <label class="credential__label">{{ 'estimates.purchase_type' | translate }}</label>
              <select #type name="type" name="purchase_type" formControlName="purchase_type"
                class="form-control credential__select-lg"
                [class.is-invalid]="estimateForm.controls.purchase_type.errors && submitted"
                (change)="purchaseTypeSelector(this.type.value)">
                <option value="" selected disabled>Select Purchase Type</option>
                <option value="wholesale">Whole Sale</option>
                <option value="retail">Retail</option>
              </select>
            </div>
          </div>

          <div class="col-sm-6 px-2 mb-3">
            <div class="form-group">
              <label class="credential__label">{{ 'estimates.city' | translate }}</label>
              <select name="city_id" formControlName="city_id" class="form-control credential__select-lg"
                [class.is-invalid]="formData.city_id.invalid && this.submitted"
                (change)="getEstimateData(this.type.value)">
                <option value="">{{ 'vin_information.city' | translate }}</option>

                <option [value]="city['city_id']" *ngFor="let city of cities">
                  <ng-container *ngIf="lang === 'en'">
                    {{ city['city_name'] }}
                  </ng-container>
                  <ng-container *ngIf="lang === 'ar'">
                    {{ city['city_name_arabic'] }}
                  </ng-container>
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-6 px-2 mb-3">
            <div class="form-group">
              <label class="credential__label"> {{ 'market_value' | translate }} </label>
              <input type="text" name="market_value" formControlName="market_value" placeholder="Not Available"
                class="form-control credential__input-lg p-3"
                [class.is-invalid]="estimateForm.controls.market_value.errors && submitted" mask="separator.10"
                thousandSeparator="" readonly>
            </div>
          </div>
          <div class="col-sm-6 px-2 mb-3">
            <div class="form-group">
              <label class="credential__label">{{ 'estimates.total_repair_cost' | translate }}</label>
              <input type="text" name="repair_total_cost" formControlName="repair_total_cost" placeholder="0.00"
                class="form-control credential__input-lg p-3"
                [class.is-invalid]="estimateForm.controls.repair_total_cost.errors && submitted" mask="separator.10"
                thousandSeparator="" readonly>
            </div>
          </div>
          <div class="col-sm-6 px-2">
            <div class="form-group">
              <label class="credential__label">{{ 'estimates.profit_percentage' | translate }}</label>
              <input type="text" name="profit_percent" formControlName="profit_percent" placeholder="0%"
                class="form-control credential__input-lg p-3"
                [class.is-invalid]="estimateForm.controls.profit_percent.errors && submitted" mask="separator.10"
                thousandSeparator="">
            </div>
          </div>

          <div class="col-sm-6 px-2">
            <div class="form-group">
              <label class="credential__label">{{ 'estimates.estimated_purchase_price_without_vat' | translate}}</label>
              <input #estimatedPurchase type="text" name="estimated_purchase_price"
                formControlName="estimated_purchase_price" placeholder="Press Calculate"
                class="form-control credential__input-lg p-3"
                [class.is-invalid]="estimateForm.controls.estimated_purchase_price.errors && submitted"
                mask="separator.10" thousandSeparator="" readonly>
            </div>
          </div>
        </div>

        <div class="vam_estimates_calculate my-4 d-none" *ngIf="!disableForm">
          <button type="button" class="btn btn__secondary w-100" [disabled]="!this.type.value"
            (click)="calculatePrice()">
            {{'estimates.calculate' | translate}}
          </button>
        </div>

        <div class="total_estimated_purchase mb-5 d-none">
          <p class="estimated_purchase_text text-center">
            {{ 'estimates.estimated_purchase_price' | translate }} (<small>{{ 'estimates.with_vat' | translate
              }}</small>):
            <span class="estimate-price color-navy-d font-weight-medium">
              SAR {{ (this.estimatedPurchase.value | number: '0.1-2') || '0.00' }}

              <button type="button" class="btn btn__action reason ml-2" [popover]="calc" placement="top"
                *ngIf="this.estimatedPurchase.value && cod > 0">
                <ion-icon name="help-circle-outline" class="ion-lg untouchable"></ion-icon>
              </button>
            </span>
          </p>
        </div>

        <div class="estimates__btnGrp" *ngIf="!loaded && !isErrorInEstimates && estimatePriceData">
          <div class="row mx-n2">
            <div class="col-sm-6 px-2 mx-auto" *ngIf="!disableForm">
              <button type="submit" class="btn btn__primary w-100" [disabled]="submitLoad">
                {{ 'save' | translate }}
                <span class="spinner-grow 
                  spinner-grow-sm 
                  text-light ml-2" [hidden]="!submitLoad">
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>


<ng-template #calc>
  <div class="calculation">
    <p class="calculation__number m-0">
      <strong>Estimated Purchase Price:</strong><span class="ml-auto">{{ (estimatedPurchasePriceWOCOD | number: '0.1-2')
        || '0.00' }}</span>
    </p>
    <p class="calculation__number m-0">
      <strong>Cost of delivery:</strong><span class="color-red ml-auto"> - {{ (cod | number: '0.1-2') || '0.00'
        }}</span>
    </p>

    <hr class="my-2">

    <p class="calculation__final text-right m-0">SAR {{ (this.estimatedPurchase.value | number: '0.1-2') || '0.00' }}
    </p>
  </div>
</ng-template>

<loader [active]="loaded"></loader>
